// AUTO-GENERATED — do not edit. Regenerate with `npm run generate-secrets`.

export const PLATFORM_ENDPOINT = "https://platform.vestaboard.com" as string | undefined;
export const APP_POSTHOG_API_KEY = "phc_muR87CZWJ8XXWGAwuuiY354eCHoGDVzoNHPhKfJC4HDs" as string | undefined;
export const APP_POSTHOG_PROXY_ENDPOINT = "https://p.vestaboard.com" as string | undefined;
export const ENVIRONMENT = "production" as string | undefined;
if (!PLATFORM_ENDPOINT) { console.warn("Missing required secret: PLATFORM_ENDPOINT"); }
if (!APP_POSTHOG_API_KEY) { console.warn("Missing required secret: APP_POSTHOG_API_KEY"); }
if (!APP_POSTHOG_PROXY_ENDPOINT) { console.warn("Missing required secret: APP_POSTHOG_PROXY_ENDPOINT"); }
if (!ENVIRONMENT) { console.warn("Missing required secret: ENVIRONMENT"); }
